import React, { useEffect, useState } from 'react';
import { checkResource } from 'utils/image_load';

type UserImageProps = {
  id: number;
  alt: string;
  path: string;
  setImageLoadError?: (set: boolean) => void;
  setImageLoaded?: () => void;
};

const loadThumbTriesMax = 10;
const triesDelay = 500;

function UserImage({
  id,
  alt,
  path,
  setImageLoaded = () => {},
  setImageLoadError = () => {},
}: UserImageProps) {
  const [imgSrc, setImgSrc] = useState(path || '/assets/blank.gif');

  // Uploads receive a url for the thumbnails before they're ready.
  // We need to wait for them to exist, so just ping the url until we get a 200,
  // then we can set the image src
  useEffect(() => {
    async function checkImage(tries = 1) {
      if (path && path !== imgSrc && tries <= loadThumbTriesMax) {
        setTimeout(async () => {
          const exists = await checkResource(path);
          if (exists) {
            setImgSrc(path);
            setImageLoaded();
          } else {
            checkImage(tries + 1);
          }
        }, tries * triesDelay);
      } else if (tries > loadThumbTriesMax) {
        setImageLoadError(true);
      }
    }

    checkImage();
  }, [path, imgSrc]);

  const handleDragStart = (e: React.DragEvent<HTMLImageElement>) => {
    const img = new Image();
    img.src = path;
    // Firefox was not adding the ghost image, so adding it manually
    e.dataTransfer.setDragImage(img, 0, 200);
    e.dataTransfer.setData('text/plain', id.toString());
  };

  return (
    <img
      className="thumb_img"
      id={`user-image-${id}`}
      src={imgSrc}
      data-id={id}
      alt={alt}
      data-original={path}
      onDragStart={handleDragStart}
    />
  );
}

export default UserImage;
